import { useLocation } from "react-router-dom";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import { useEffect, useRef, useState } from "react";
import { apiRequest } from "@vojomo-core/shared";

export const FileViewer = () => {
  const id = useLocation().pathname.split("/")[3];
  const firstRender = useRef(true);
  const [fileLink, setFileLink] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    apiRequest({
      subRoute: "operating",
      path: `/get_file_info?file_key=${id}`
    }).then((fileInfo) => {
      if (fileInfo !== null) {
        let fileKey = id;
        let gid = null;

        if (fileKey.includes("gid")) {
          gid = fileKey.split("gid=")[1];
          fileKey = fileKey.split("gid=")[0].replace("&", "");
        }

        console.log(gid);
        const fileData: any = fileInfo;
        const fileLink = gid
          ? "https://docs.google.com/spreadsheets/d/" +
            fileKey +
            "/edit?gid=" +
            gid +
            "#gid=" +
            gid
          : fileData?.file_link;

        console.log(fileLink);

        setFileLink(fileLink);
        setFileName(fileData?.file_name);
      }
    });
    firstRender.current = false;
  }, []);

  const displayOutput =
    fileLink && firstRender ? (
      <OperatingLayout pageHeader={fileName}>
        <iframe
          style={{
            borderRadius: "10px",
            borderColor: "grey",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "100%",
            height: "75vh"
          }}
          src={fileLink}
        />
      </OperatingLayout>
    ) : (
      <OperatingLayout pageHeader="">
        <></>
      </OperatingLayout>
    );

  return <>{displayOutput}</>;
};
